<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addStoreExpress"
        >添加快递配送</el-button
      >
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.expressName"
          placeholder="模板名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          placeholder="运费类型"
          v-model="searchCondition.feeCalcMode"
          class="mr10"
          filterable
        >
          <el-option label="距离" value="weight"></el-option>
          <el-option label="件数" value="number"></el-option>
        </el-select>
        <el-cascader
          clearable
          class="mr10"
          ref="cascader"
          v-model="searchCondition.queryAreaCodeRegion"
          :props="queryProps"
          :show-all-levels="false"
          filterable
          size="small"
          placeholder="请选择收货地区"
        ></el-cascader>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <div class=" table-box" v-for="(v, i) in list" :key="i">
        <div class="flex flex-between table-border item-center">
          <div class="flex-1 flex flex-wrap ml20">
            <div class="flex-1">
              {{ v.expressName }}
            </div>
            <div class="flex-1">最近编辑时间:{{ v.updateTime }}</div>
          </div>
          <div class="flex-1 flex flex-end mr10">
            <el-button size="small" type="text" @click="edit(v)" class="blue"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="remove(v)"
              class="danger"
              >删除</el-button
            >
          </div>
        </div>
        <div class="table-content " v-if="v.feeCalcMode === 'number'">
          运费规则： 首 {{ v.lowerLimitNumber }} 件,邮费
          {{ v.lowerLimitExpressyFee }} ,超出部分,每件邮费
          {{ v.overPerPrice }} 元
        </div>
        <div class="table-content " v-if="v.feeCalcMode === 'weight'">
          运费规则： 首 {{ v.lowerLimitNumber }} KG,邮费
          {{ v.lowerLimitExpressyFee }} ,超出部分,每KG邮费
          {{ v.overPerPrice }} 元
        </div>
        <div class="table-content " v-if="v.feeCalcMode === 'gratis'">
          运费规则：免邮
        </div>
        <div class="flex flex-wrap table-content ">
          <div>
            适配地区：
          </div>
          <div v-for="(j, ii) in v.areaCodeRegionList" :key="ii">
            {{ ii !== 0 ? "、" : "" }}{{ j.provinceName }}
          </div>
        </div>
      </div>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="配送名称" prop="expressName">
          <el-input
            clearable
            v-model="ruleForm.expressName"
            size="small"
            placeholder="请输入配送名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="seqNum">
          <el-input
            type="number"
            @mousewheel.prevent.native
            clearable
            @input="filterGt0('seqNum')"
            v-model="ruleForm.seqNum"
            size="small"
            placeholder="请输入排序值"
          ></el-input>
          <span>排序值影响手机端的显示顺序，数字越小越靠前</span>
        </el-form-item>
        <el-form-item
          label="费用计算方式"
          prop="feeCalcMode"
          v-if="feeCalcModeList2.length > 0"
        >
          <el-radio-group
            v-model="ruleForm.feeCalcMode"
            @change="feeCalcModeChange"
          >
            <el-radio
              v-for="(item, i) in feeCalcModeList2"
              :label="item.itemValue"
              :key="i"
              >{{ item.itemText }}</el-radio
            >
          </el-radio-group>
          <!-- 按重量计算 -->
          <div v-if="ruleForm.feeCalcMode === 'weight'">
            首<el-input
              type="number"
              @mousewheel.prevent.native
              clearable
              style="width:100px;"
              v-model="ruleForm.lowerLimitNumber"
              @input="filterGt0OrFixed2('lowerLimitNumber')"
              size="small"
            ></el-input
            >KG,邮费<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitExpressyFee"
              @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
              size="small"
            ></el-input>
            <div>
              超出部分,每KG邮费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input>
            </div>
            <div>
              <!-- 满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.lowerLimitAmount"
                @input="filterGt0OrFixed2('lowerLimitAmount')"
                size="small"
              ></el-input
              >元起送, -->
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元包邮
            </div>
          </div>
          <!-- 按件数收费 -->
          <div v-if="ruleForm.feeCalcMode === 'number'">
            首<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitNumber"
              @input="filterGt0('lowerLimitNumber')"
              size="small"
            ></el-input
            >件,邮费<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitExpressyFee"
              @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
              size="small"
            ></el-input>
            <div>
              超出部分,每件邮费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input>
            </div>
            <div>
              <!-- 满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.lowerLimitAmount"
                @input="filterGt0OrFixed2('lowerLimitAmount')"
                size="small"
              ></el-input
              >元起送, -->
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元包邮
            </div>
          </div>
        </el-form-item>

        <el-form-item label="是否启用" prop="enabledState">
          <el-switch
            :disabled="disabled"
            v-model="ruleForm.enabledState"
            active-color="#2d8"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <el-form-item label="配送范围" prop="areaCodeRegion">
          <!-- <el-button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="openAuthorizeDialog"
            >选择配送范围</el-button
          > -->
          <div class="flex flex-start">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
              >全选</el-checkbox
            >
          </div>
          <div class="area-style flex flex-wrap" v-if="dialogVisible">
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree1"
              :load="loadNode1"
              lazy
              highlight-current
              @check-change="handleCheckChange"
              show-checkbox
            ></el-tree>
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree2"
              :load="loadNode2"
              lazy
              highlight-current
              show-checkbox
            ></el-tree>
            <el-tree
              empty-text="暂无权限"
              class="tree-style flex-1 flex-center"
              :props="props"
              node-key="value"
              ref="tree3"
              :load="loadNode3"
              lazy
              highlight-current
              show-checkbox
            ></el-tree>
          </div>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="选择配送范围"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <div class="caption">所有的配送范围：</div>
        <el-tree
          empty-text="暂无权限"
          :props="props"
          node-key="value"
          ref="tree"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown trigger="click" @command="selectItem">
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="checkAll">全部勾选</el-dropdown-item>
              <el-dropdown-item command="cancleCheckAll"
                >取消全选</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer> -->
  </hm-content>
</template>

<script>
import area from "@/utils/area";
import { arrayUnique2 } from "@/utils/utils";
export default {
  components: {},
  data() {
    const patternAreaCodeRegionFunc = function(rule, val, callback) {
      this.ruleForm.areaCodeRegion = [
        ...this.$refs.tree1.getCheckedNodes().map(v => v.value),
        ...this.$refs.tree2.getCheckedNodes().map(v => v.value),
        ...this.$refs.tree3.getCheckedNodes().map(v => v.value)
      ];

      if (!this.ruleForm.areaCodeRegion.length > 0) {
        return callback(new Error("请选择配送范围"));
      }
      callback();
    }.bind(this);
    const patternPointsRatioFunc = function(rule, val, callback) {
      if (val === "number") {
        if (
          !this.ruleForm.lowerLimitNumber ||
          !this.ruleForm.lowerLimitExpressyFee ||
          !this.ruleForm.overPerPrice ||
          // !this.ruleForm.lowerLimitAmount ||
          !this.ruleForm.freeShipAmount
        ) {
          return callback(new Error("请填写所有项"));
        }
      } else if (val === "weight") {
        if (
          !this.ruleForm.lowerLimitNumber ||
          !this.ruleForm.lowerLimitExpressyFee ||
          !this.ruleForm.overPerPrice ||
          // !this.ruleForm.lowerLimitAmount ||
          !this.ruleForm.freeShipAmount
        ) {
          return callback(new Error("请填写所有项"));
        }
      }

      callback();
    }.bind(this);
    return {
      queryProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store.dispatch("queryRegionCode").then(res => {
              // res.result.records.forEach(v => {
              //   v.leaf = Boolean(!v.isParent);
              //   v.value = v.orgCode;
              //   v.label = v.departName;
              // });
              resolve(res.result);
            });
          } else {
            this.$store
              .dispatch("queryRegionCode", {
                value: data.value,
                level
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = v.level === "3" ? true : false;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      searchCondition: {},
      checkAll: false,
      flag: false,
      list: [],
      keyWords: "",
      title: "",
      total: 0,
      area,
      data: [],
      disabled: false,
      pageSize: 10,
      currentPage: 1,
      pageSizeAdress: 10,
      currentPageAdress: 1,
      dialogVisible: false,
      authorizeDialogVisible: false,
      dialogVisibleAdress: false,
      feeCalcModeList2: [],
      leftRules: [],
      expressId: "",
      ruleForm: {
        seqNum: "",
        lowerLimitNumber: "",
        expressMode: "",
        expressName: "",
        feeCalcMode: "",
        expressFee: "",
        freeShipAmount: "",
        baseDistanceUpperLimit: "",
        overPerkmPrice: "",
        baseWeightUpperLimit: "",
        overPerkgPrice: "",
        areaCodeRange: "yes",
        enabledState: "no",
        lowerLimitExpressyFee: "",
        overPerPrice: "",
        areaCodeRegion: [],
        expressId: ""
      },
      rules: {
        expressMode: [
          {
            required: true,
            message: "请选择配送方式",
            trigger: "blur"
          }
        ],
        expressName: [
          {
            required: true,
            message: "请填写配送名称",
            trigger: "blur"
          },
          {
            max: 20,
            message: "名称应小于20个字",
            trigger: "blur"
          }
        ],
        feeCalcMode: [
          {
            required: true,
            message: "请选择费用计算方式",
            trigger: "blur"
          },
          {
            required: true,
            validator: patternPointsRatioFunc,
            trigger: "blur"
          }
        ],
        areaCodeRange: [
          {
            required: true,
            // message: "请选择费用计算方式",
            trigger: "blur"
          }
        ],
        areaCodeRegion: [
          {
            required: true,
            validator: patternAreaCodeRegionFunc,
            trigger: "blur"
          }
        ]
      },
      props: {
        isLeaf: "leaf",
        label: "label",
        children: "children",
        disabled: this.disabledFn
      },
      expressDisabledList: [],
      disabledList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryFeeCalcModeList2();
  },
  methods: {
    unique(arr) {
      return Array.from(new Set(arr));
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        let list = this.$refs.tree1
          .getCheckedNodes()
          .concat(this.$refs.tree1.getHalfCheckedNodes());

        this.disabledList.push(...list.map(o => o.value));
        this.disabledList = this.unique(this.disabledList);
      } else {
        let list = this.$refs.tree1
          .getCheckedNodes()
          .concat(this.$refs.tree1.getHalfCheckedNodes());
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    remove(v) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delStoreExpress", { expressId: v.expressId })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    feeCalcModeChange() {
      this.ruleForm.lowerLimitNumber = "";
      this.ruleForm.lowerLimitExpressyFee = "";
      this.ruleForm.overPerPrice = "";
      this.ruleForm.freeShipAmount = "";
    },
    handleCheckAllChange(val) {
      if (val) {
        this.expressDisabledList.forEach(v => {
          this.data.forEach(j => {
            if (v === j.value) {
              j.isRepeat = true;
            }
          });
        });
        let list = [];
        this.data.map(item => {
          if (!item.isRepeat) {
            list.push(item);
          }
        });
        this.$refs.tree1.setCheckedNodes(list);
        this.$refs.tree2.setCheckedNodes(list);
        this.$refs.tree3.setCheckedNodes(list);
      } else {
        this.$refs.tree1.setCheckedKeys([]);
        this.$refs.tree2.setCheckedKeys([]);
        this.$refs.tree3.setCheckedKeys([]);
      }
    },

    disabledFn(data) {
      return this.expressDisabledList.includes(data.value) || data.disabled;
    },
    edit(row) {
      this.title = "编辑详情";

      let params = {
        expressId: row.expressId
      };
      this.$store.dispatch("detailsStoreExpress", params).then(res => {
        if (res.code === "0") {
          this.expressDisabledList = res.result.forbiddenRegionList || [];

          for (let key in this.ruleForm) {
            this.ruleForm[key] = res.result[key];
          }
          //   let list = [];
          //   this.ruleForm.areaCodeRegion.forEach(v=>{
          //       list.push({v,true})
          //   })
          this.dialogVisible = true;

          setTimeout(() => {
            this.$refs.tree1.setCheckedKeys(this.ruleForm.areaCodeRegion);
            this.$refs.tree2.setCheckedKeys(this.ruleForm.areaCodeRegion);
            this.$refs.tree3.setCheckedKeys(this.ruleForm.areaCodeRegion);
          }, 0);
        }
      });
    },
    // feeCalcModeChange(val) {
    //   this.costType = val;
    // },
    queryFeeCalcModeList2() {
      return this.$store.dispatch("queryFeeCalcModeList2").then(res => {
        this.feeCalcModeList2 = res.result;
      });
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0(prop) {
      if (this.ruleForm[prop].length == 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          this.$store
            .dispatch(
              this.title === "添加快递配送"
                ? "saveStoreExpressConfig"
                : "editStoreExpress",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.resetRuleForm();
                this.dialogVisible = false;
                this.queryList();
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      if (node.level < 3) {
        this.$store
          .dispatch("queryRegionCode", {
            value: node.data.value,
            level: node.level
          })
          .then(res => {
            const data = res.result;

            data.forEach(v => {
              v.leaf = v.level === "3" ? true : false;
              v.disabled = node.disabled;
            });

            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    loadNode1(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            let a = res.result.splice(0, 10);
            let b = res.result.splice(0, 10);
            let c = res.result;
            this.data = res.result;

            let list = [];
            for (let i = 0; i < 10; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    loadNode2(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            this.data = res.result;

            let list = [];
            for (let i = 10; i < 20; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    loadNode3(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            this.data = res.result;

            let list = [];
            for (let i = 20; i < res.result.length; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    openAuthorizeDialog() {
      this.authorizeDialogVisible = true;
      setTimeout(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.areaCodeRegion);
      }, 0);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStoreExpressList",
        params
      );
      this.list = result.records;
      this.total = result.total;
    },
    addStoreExpress() {
      this.title = "添加快递配送";
      this.dialogVisible = true;
      this.expressDisabledList = [];
      this.resetRuleForm();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid rgba(221, 221, 221, 1);
  .table-box {
    // border: 1px solid #222;
    .table-border {
      // border: 1px solid #222;
      background: #ddd;
      font-size: 14px;
      font-weight: bold;
    }
    .table-rule {
      //   height: 34px;
      line-height: 34px;
      font-weight: bold;
    }
    .table-content {
      font-size: 14px;
      font-weight: 400;
      line-height: 15px;
      font-family: PingFang SC;
      color: #222;
      padding: 10px 20px;
    }
  }
}
</style>
